import type { Option } from '@cometjs/core';
import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { mapOption } from '@cometjs/core';

import type { LinkType } from '../link';
import { mapLinkType, linkToString } from '../link';

type LinkProps = {
  link: Option<LinkType>,
  className?: string,
  children?: React.ReactNode,
  onClick?: React.MouseEventHandler<HTMLElement>,
};

const Link: React.FC<LinkProps> = ({
  link,
  className,
  children,
  onClick,
}) => {
  return mapOption(link, {
    none: (
      <span className={className}>
        {children}
      </span>
    ),
    some: link => mapLinkType(link, {
      // eslint-disable-next-line react/display-name
      internal: link => (
        <GatsbyLink to={linkToString(link)} className={className} onClick={onClick}>
          {children}
        </GatsbyLink>
      ),
      // eslint-disable-next-line react/display-name
      external: link => (
        <a
          href={linkToString(link)}
          target="_blank"
          rel="noopener"
          className={className}
          onClick={onClick}
        >
          {children}
        </a>
      ),
    }),
  });
};

export default Link;
